'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { Check, Globe, Languages } from 'lucide-react';
import { useLocale } from 'next-intl';
import { usePathname, useRouter } from '@/core/i18n/navigation';
import { localeNames } from '@/config/locale';
import { Button } from '@/shared/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/shared/components/ui/dropdown-menu';
import { cacheSet } from '@/shared/lib/cache';
const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
function setPreferredLocaleCookie(locale: string) {
  document.cookie = `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)}; Path=/; Max-Age=${LOCALE_COOKIE_MAX_AGE}; SameSite=Lax`;
}
export function LocaleSelector(t0) {
  const $ = _c(26);
  const {
    type: t1
  } = t0;
  const type = t1 === undefined ? "icon" : t1;
  const currentLocale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== currentLocale || $[3] !== pathname || $[4] !== router || $[5] !== searchParams) {
    t4 = value => {
      if (value !== currentLocale) {
        cacheSet("locale", value);
        setPreferredLocaleCookie(value);
        const query = searchParams?.toString?.() ?? "";
        const href = query ? `${pathname}?${query}` : pathname;
        router.push(href, {
          locale: value
        });
      }
    };
    $[2] = currentLocale;
    $[3] = pathname;
    $[4] = router;
    $[5] = searchParams;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSwitchLanguage = t4;
  if (!mounted) {
    const t5 = type === "icon" ? "Change language" : undefined;
    const t6 = type === "icon" ? "ghost" : "outline";
    const t7 = type === "icon" ? "icon" : "sm";
    const t8 = type === "icon" ? "h-auto w-auto p-0" : "hover:bg-primary/10";
    let t9;
    if ($[7] !== currentLocale || $[8] !== type) {
      t9 = type === "icon" ? <Languages size={18} /> : <><Globe size={16} />{localeNames[currentLocale]}</>;
      $[7] = currentLocale;
      $[8] = type;
      $[9] = t9;
    } else {
      t9 = $[9];
    }
    let t10;
    if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
      t10 = <Button aria-label={t5} variant={t6} size={t7} className={t8} disabled={true}>{t9}</Button>;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
      $[13] = t8;
      $[14] = t9;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    return t10;
  }
  let t5;
  if ($[16] !== currentLocale || $[17] !== type) {
    t5 = <DropdownMenuTrigger asChild={true}>{type === "icon" ? <Button aria-label="Change language" variant="ghost" size="icon" className="h-auto w-auto p-0"><Languages size={18} /></Button> : <Button variant="outline" size="sm" className="hover:bg-primary/10"><Globe size={16} />{localeNames[currentLocale]}</Button>}</DropdownMenuTrigger>;
    $[16] = currentLocale;
    $[17] = type;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.keys(localeNames);
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== currentLocale || $[21] !== handleSwitchLanguage) {
    t7 = <DropdownMenuContent>{t6.map(locale => <DropdownMenuItem key={locale} onClick={() => handleSwitchLanguage(locale)}><span>{localeNames[locale]}</span>{locale === currentLocale && <Check size={16} className="text-primary" />}</DropdownMenuItem>)}</DropdownMenuContent>;
    $[20] = currentLocale;
    $[21] = handleSwitchLanguage;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t7) {
    t8 = <DropdownMenu>{t5}{t7}</DropdownMenu>;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}